export default {
  rental: {
    banner: {
      imageUrl: 'https://assets.homedepot-static.com/mcstore/images/rentals/hero-banner-2x.jpg',
      alt: 'concrete drill drilling into cinder blocks'
    },
    caption: {
      top: 'All Your Rental Needs In One Place',
      bottom: 'Our Rental Center has everything you need to get the job done right.'
    },
    logo: {
      imageUrl: 'https://assets.homedepot-static.com/mcstore/images/rentals/tool-rental-largelogo.png',
      alt: 'the home depot logo in line with the word Rental in bold'
    },
    title: 'Do you need a tool or truck rental to complete your project?'
  },
  home: {
    banner: {
      imageUrl: 'https://assets.homedepot-static.com/mcstore/images/HomeServices-938x157Desktop.png',
      alt: 'pro installer with home depot shirt using power drill on wooden furniture'
    },
    caption: {
      top: 'Explore The Home Depot\'s Services to discover how we can help you with your next project.',
      bottom: ''
    },
    logo: {
      imageUrl: 'https://assets.thdstatic.com/mcstore/images/icons/logo-do-it-for-you.svg',
      alt: 'the home depot logo with home services and tag line let us do it for you'
    },
    title: 'What project can we do for you?'
  },
  garden: {
    banner: {
      imageUrl: 'https://assets.thdstatic.com/images/v1/garden-center-banner.jpg',
      alt: 'pro installer with home depot shirt using power drill on wooden furniture'
    },
    caption: {
      top: 'Explore Your Local Garden Center at a Home Depot Near You. ',
      bottom: 'Get inspired to upgrade your plants and landscaping.'
    },
    logo: {
      imageUrl: 'https://assets.thdstatic.com/images/v1/logo-how-doers-get-more-done.png',
      alt: 'the home depot logo with home services and tag line let us do it for you'
    },
    title: 'Do you have what you need to make your garden grow?'
  }
};